module.exports = __webpack_public_path__ + "img/24.82cbe453.svg";